// Shared FontFace loader + already-loaded cache — used by both TextTool.tsx
// (Add Text) and PropertyPanel.tsx (Edit Text) so a font loaded via one
// panel is recognized as already-loaded by the other instead of each
// tracking its own separate cache and silently reloading the same font.
const loadedFonts = new Set<string>();

export async function ensureFontLoaded(fontLabel: string, fontFileUrl: string): Promise<void> {
  if (loadedFonts.has(fontLabel)) return;
  if (!('FontFace' in window)) { loadedFonts.add(fontLabel); return; }
  try {
    const face = new FontFace(fontLabel, `url(${fontFileUrl})`);
    const loaded = await face.load();
    (document.fonts as any).add(loaded);
    await document.fonts.ready;
    loadedFonts.add(fontLabel);
  } catch {
    // Non-fatal: font may already be available via CSS @font-face
    loadedFonts.add(fontLabel);
  }
}
